import { HotTable } from '@handsontable/react'
import { useTableConfiguration } from './listTable/useTableConfiguration'
import { useListObserver } from './useListObserver'
import '../list-manager.global.css'

import { Button } from '@components/v2/button'
import { CirclePlus } from 'lucide-react'
import { t } from '@lingui/core/macro'

export const ListTableContainer = ({ listId, setIsNewColumnModalOpen }) => {
  const { data: list } = useListObserver({ listId })

  const { settings, setTableRef, setContainerRef } = useTableConfiguration({ list })

  const length = list?.list_columns?.length || 0
  const hasColumns = length > 0
  const isDropdown = list?.type === 'drop-down'
  const hasSingleColumn = length === 1

  return (
    <div className="flex items-start overflow-auto h-full">
      {hasColumns ? (
        <div ref={setContainerRef} id="list-container">
          <HotTable ref={setTableRef} settings={settings} width={300 * length + 1} />
        </div>
      ) : null}

      {isDropdown && hasSingleColumn ? null : (
        <Button
          variant="secondary"
          className="border-dashed !text-black flex gap-2 items-center m-8"
          onClick={() => setIsNewColumnModalOpen(true)}
        >
          <CirclePlus size={21} color="#a9c5d0" />
          {t`Add new column`}
        </Button>
      )}
    </div>
  )
}
